import { ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { Component } from '@angular/core';
import { ProjectService } from '@wms/app/services'; 

@Component({
  standalone: true,
  selector: 'wms-autocode-agentic-chat',
  templateUrl: './agentic-chat.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AgenticChatComponent {
  appBaseMetaInfo: any;

  constructor(private projectService: ProjectService, @Inject(ElementRef) private hostElement: ElementRef, @Inject("APP_BUILD_META_INFO") appBaseMetaInfo: any ) {
    this.appBaseMetaInfo = appBaseMetaInfo;
  }
  ngAfterViewInit() {
    const shadowRoot = (this.hostElement.nativeElement as HTMLElement).shadowRoot;
    let basePath = this.appBaseMetaInfo.CDN_BASE_URL ? this.appBaseMetaInfo.CDN_BASE_URL + '' : '/studio/';

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = basePath + 'assets/agentic-chat/autocode-preview-agentic-chat.css';

    shadowRoot?.appendChild(link);
    const container = shadowRoot?.querySelector('#agentic-chat-interface');
    if (typeof (window as any).AgenticChat === 'function') {
      (window as any).AgenticChat(container, {
        projectId: this.projectService.getProjectId(),
        name: 'AngularHost',
      });
    }
  }
}
